export function toDictionary<T extends object, K extends keyof T>(
  values: T[],
  key: K,
): Map<T[K], T> {
  return new Map(values.map((value) => [value[key], value]))
}
